module.exports = __webpack_public_path__ + "f3b1e41c2c5f9b803ccf39631a48e9c1.MP3";